import { isEmpty } from 'lodash';
import { getFilterComponent, getSortComponent } from '@shared/data/cards/CardsEntityService';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';
import { ControlsState } from '../types';

type Props = Pick<ControlsState, 'filters' | 'sorts' | 'groups'>;

export function mapStateToCollectionCriteria({
  filters,
  sorts,
  groups,
}: Props): API.CollectionCriteriaFragment {
  const updatedFilters = Array.from(filters.values()).map(getFilterComponent).filter(notNil);

  const updatedSorts = Array.from(sorts.values()).map(getSortComponent);

  const updatedGroups = groups
    .filter(group => !isEmpty(Array.from(group.values())))
    .map(group => ({
      filterByComponents: Array.from(group.values()).map(getFilterComponent).filter(notNil),
    }));

  return {
    filterByComponents: updatedFilters,
    sortByComponents: updatedSorts,
    groups: updatedGroups,
  };
}
